import { Component } from '@angular/core';
import { PageTitleComponent } from "@shared/components/page-title/page-title.component";
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-threed-controller',
  standalone: true,
  imports: [
    PageTitleComponent,
    TranslatePipe
  ],
  templateUrl: './threed-controller.component.html',
  styleUrl: './threed-controller.component.scss'
})
export class ThreedControllerComponent {
  breadCrumbItems = [
    {
      label: 'Smart Controller',
    },
    {
      label: '3D Controller',
      active: true,
    }
  ]
}
